import businessClient from 'src/services/clients/business'
import { IMeta, ISalesTax } from 'src/common/interfaces/index.js'

const ISalesTaxListResponse = { meta: IMeta, data: { list: [ISalesTax] } }

export const salesTax = {
  /**
   * @param {id: number} filter
   * @return {Promise<ISalesTaxListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('sales-tax/portal/list', { filter }, { signal })
  },

  /**
   * @param {ISalesTax} data
   * @return {Promise<ISalesTaxListResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('sales-tax/upsert', { data }, { signal })
  },

  /**
   * @param {store_id: number; id: number} filter
   * @return {Promise<ISalesTaxListResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('sales-tax/archive', { filter }, { signal })
  },
}
